import React from 'react';

import { FormControlLabel, InputLabel, RadioGroup as MUIRadioGroup, Radio, RadioGroupProps } from '@mui/material';
import { Control, FieldPath, FieldValues } from 'react-hook-form';
import { useController, useId } from 'hooks';
import { SelectorValue } from 'types/types';

import styles from './styles.module.sass';

type Properties<T extends FieldValues> = {
  control: Control<T, null>;
  name: FieldPath<T>;
  label: string;
  values: SelectorValue[];
} & RadioGroupProps;

export const RadioGroup = <T extends FieldValues>({ control, name, values, label, ...props }: Properties<T>) => {
  const { field } = useController({ name, control });
  const { value, onChange } = field;
  const id = useId();

  return (
    <div className={styles.container}>
      <InputLabel className={styles.label} id={id}>
        {label}
      </InputLabel>
      <MUIRadioGroup {...props} id={id} value={value} onChange={onChange} data-testid={`radio-${name}`}>
        {values.map(({ label, id }) => (
          <FormControlLabel value={id} control={<Radio />} label={label} key={id} />
        ))}
      </MUIRadioGroup>
    </div>
  );
};
